import { render, staticRenderFns } from "./CarPartsSelect.vue?vue&type=template&id=daddcebc&"
import script from "./CarPartsSelect.vue?vue&type=script&lang=js&"
export * from "./CarPartsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports